import { Box, Divider, Grid2 } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useDocumentTitle from "utils/useDocumentTitle";
import GKButton from "./GKButton";
import GKTypography from "./GKTypography";

const ErrorPage = ({ resetErrorBoundary }: any) => {
  useDocumentTitle("404");

  const navigate = useNavigate();

  return (
    <Grid2 container height={"100vh"} width={"100vw"}>
      <Grid2
        size={5.6}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"flex-end"}
        flexDirection={"column"}
        gap={2}
      >
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"flex-end"}
          flexDirection={"column"}
        >
          <GKTypography fontSize={22} fontWeight={900}>
            Some Error Occurred !
          </GKTypography>
          <GKTypography
            fontSize={14}
            color={"var(--grey-500)"}
            width={"80%"}
            textAlign={"right"}
          >
            {` Apologies for the inconvenience — we're currently working on it.
            Please try again shortly.
`}{" "}
          </GKTypography>
        </Box>
        <GKButton
          variant="outlined"
          size="medium"
          onClick={() => {
            navigate("/app/dashboard");
            resetErrorBoundary();
          }}
        >
          {" "}
          Go Back Home
        </GKButton>
      </Grid2>
      <Grid2 size={0.8}>
        <Divider orientation="vertical" />
      </Grid2>
      <Grid2
        size={5.6}
        display={"flex"}
        justifyContent={"flex-start"}
        alignItems={"center"}
      >
        <img src="/404.svg" alt="" width={"80%"} />
      </Grid2>
    </Grid2>
  );
};
export default ErrorPage;
